import { useEffect } from "react";

export const JivoChat = () => {
  useEffect(() => {
    const jivoScript = document.createElement("script");
    jivoScript.src = "//code.jivosite.com/widget/hgEVNvTg71";
    jivoScript.async = true;

    document.body.appendChild(jivoScript);

    return () => {
      document.body.removeChild(jivoScript);
    };
  }, []);

  return null;
};
